import { useContext } from "react";
import { ListRecordContext } from ".";

export const useListRecord = () => {
    const context = useContext(ListRecordContext)

    return context;
}